import { Box, Button, Container, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { useUrlSearchParamOrganization } from '../../components/contexts/hooks/url';

export const SmartCheckUnavailablePage: React.FC = () => {
  const organizationParam = useUrlSearchParamOrganization();
  return (
    <Container>
      <Box display="flex" justifyContent="center">
        <Typography variant="body1">SmartCheckを利用できるのは、小店舗グループのみです</Typography>
      </Box>
      <Box display="flex" justifyContent="center">
        <Button component={Link} to={{ pathname: '/', search: organizationParam }}>
          ホームに戻る
        </Button>
      </Box>
    </Container>
  );
};
